import store from "../store";
import axios from "axios";
import QS from "qs";

export default {
    get_urlSite: function (){
        let urlSite;
        let subdomain = '/'
        if (location.hostname === 'localhost') {
            urlSite = 'http://localhost:8080/donorportal/';
        } else {
            const arrPathname = location.pathname.split('/')
            if (arrPathname[1] === 'coordinator') {
                subdomain = '/coordinator/'
            } else {
                subdomain = '/'
            }
            urlSite = location.origin + subdomain

            return urlSite
        }
    },
    setLocalStorage: function (LSName, LSValue) {
        localStorage.setItem(LSName, LSValue);
    },
    getLocalStorage: function(LSName) {
        return localStorage.getItem(LSName)
    },
    cleanLocalStorage: function (LSNname) {
        localStorage.removeItem(LSNname)
    },
    cleanAllLocalStorages: function () {
        localStorage.clear()
    },
    getCookie: function(name) {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\\.$?*|{}\\(\\)\\[\]\\/\\+^])/g, '\\$1') + "=([^;]*)"
        ))
        return matches ? decodeURIComponent(matches[1]) : undefined
    },
    setCookie: function (cname, cvalue, minutes) {
        let date = new Date()
        let expires = ""
        if(minutes !== 0){
            date.setMinutes(date.getMinutes() + minutes)
            expires = "expires="+ date.toUTCString();
        }

        const urlCookies = this.get_urlSite()
        document.cookie = cname + "=" + cvalue  + "; path=" + urlCookies + "/; " + expires;
    },
    cleanCookie: function (cname) {
        const urlCookies = this.get_urlSite()
        document.cookie = cname + "=; path=" + urlCookies + "/; expires=Thu, 01 Jan 1970 00:00:00 GMT;";
    },
    getData: (arrUrlData)=>{
        if (arrUrlData !== '') {
            arrUrlData = arrUrlData.replace('?', '').split('&');
        } else {
            return;
        }
        if (arrUrlData.length >= 1) {
            let arrFinishData = {};
            arrUrlData.forEach(function (item) {
                if (item !== '') arrFinishData[keyOrVal(item, 'key')] = keyOrVal(item, 'val');

                function keyOrVal(item, flag) {
                    let arrArr = item.split('=');
                    if (arrArr.length <= 1) return 'Error not "="'
                    switch (flag) {
                        case 'key':
                            return arrArr[0];
                        case 'val':
                            return arrArr[1];
                        default:
                            return 'Error in flag';
                    }
                }
            });
            return arrFinishData;
        }
    },
    createMaskForPhone: function(template, selectedFormat, aggregate ){
        //Only for USA phone country code
        console.log('template = ', template, '  selectedFormat = ', selectedFormat );

        const result = template.replaceAll(selectedFormat, '');
        const trimResult = result.trim();
        let resultWithoutPhoneCode = trimResult;
        let checkPhoneCode = false;
        if(trimResult[0] === '+'){
            resultWithoutPhoneCode = trimResult.replace('+1', '');
            checkPhoneCode = true;
        }

        const mask = resultWithoutPhoneCode.replace(/[0-9]/g, aggregate);

        return checkPhoneCode ? "+1" + mask : mask;
    },
    phoneFormat: function(phone, format_phone){
        let phoneClean = phone.replace(/[^0-9]/g, '');
        let formatPhone='';
        let i=0;
        switch(format_phone){
            case 'Free Format':
                for(let keyPhone=phoneClean.length-1; keyPhone>=0; keyPhone --){
                    if(i==14){
                        break
                    }
                    formatPhone = phoneClean[keyPhone] + formatPhone;
                    i++;
                }
                if (i>10){
                    formatPhone = '+' + formatPhone
                }
                break;
            case 'USA Format':
                for(let keyPhone=phoneClean.length-1; keyPhone>=0; keyPhone --){
                    if(i==3){
                        formatPhone= '-' + phoneClean[keyPhone] + formatPhone;
                        i=10;
                        continue;
                    }
                    if(i==12){
                        formatPhone= ') ' + phoneClean[keyPhone] + formatPhone;
                        i=20;
                        continue;
                    }
                    if(i==22){
                        formatPhone= ' (' + phoneClean[keyPhone] + formatPhone;
                        i=30;
                        continue;
                    }
                    if(i==34){
                        break
                    }
                    formatPhone = phoneClean[keyPhone] + formatPhone;
                    i++;
                }
                if (i>30){
                    formatPhone = '+' + formatPhone
                }
                break
            case 'USA Format (short)':
                for(let keyPhone=phoneClean.length-1; keyPhone>=0; keyPhone --){
                    if(i==3){
                        formatPhone= '-' + phoneClean[keyPhone] + formatPhone;
                        i=10;
                        continue;
                    }
                    if(i==12){
                        formatPhone= '-' + phoneClean[keyPhone] + formatPhone;
                        i=20;
                        continue;
                    }
                    if(i==22){
                        formatPhone= ' ' + phoneClean[keyPhone] + formatPhone;
                        i=30;
                        continue;
                    }
                    if(i==34){
                        break
                    }
                    formatPhone = phoneClean[keyPhone] + formatPhone;
                    i++;
                }
                if (i>30){
                    formatPhone = '+' + formatPhone
                }
                break
            case 'No Format':
            default:
                formatPhone = phone;
        }
        return formatPhone;
    },
    getRandomInt: (max) => {
        return Math.floor(Math.random() * Math.floor(max));
    },
    getRandomInRange: (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    validationEmail: (email) => {
        let reEmail = /^([A-Za-z0-9_\-\\.])+\\@([A-Za-z0-9_\-\\.])+\.([A-Za-z]{2,4})$/;
        return reEmail.test(email);
    },
    phoneCleaner: (phone)=> {
        let deleteCountryCode = phone
        if (phone[0] === '+'){
            deleteCountryCode = phone.replace('+1', '')
        }
        return deleteCountryCode.replace(/[^0-9]/g, '');
    },
    phoneCleanerForSms: (phone)=> {
        return phone.replace(/[^0-9\\+]/g, '');
    },
    errorCheckValidationPassword: (passMinLength, passUppercaseCharacters, passLowercaseCharacters, passContainNumbers, passSpecialCharacters, pass)=> {
        let checkMessage = false;
        let errorMessage = 'Password must contain:\n';
        let atLeastLowerCase = /[a-z]/;
        let atLeastUpperCase = /[A-Z]/;
        let atLatestNumbers = /[0-9]/;
        let atLeastSpecial = /[\\@\\#\\%\\^\\&\\*\]\\)]/;

        if (passMinLength && pass.length < passMinLength) {
            checkMessage = true;
            errorMessage = errorMessage + '- at least ' + passMinLength + ' characters;\n';
        }
        if (passUppercaseCharacters == 1) {
            if (atLeastUpperCase.test(pass) === false) {
                checkMessage = true;
                errorMessage = errorMessage + '- at least one uppercase letter;\n';
            }
        }
        if (passLowercaseCharacters == 1) {
            if (atLeastLowerCase.test(pass) === false) {
                checkMessage = true;
                errorMessage = errorMessage + '- at least one lowercase letter\n';
            }
        }
        if (passContainNumbers == 1) {
            if (atLatestNumbers.test(pass) === false) {
                checkMessage = true;
                errorMessage = errorMessage + '- at least one letter and one number;\n';
            }
        }
        if (passSpecialCharacters == 1) {
            if (atLeastSpecial.test(pass) === false) {
                checkMessage = true;
                errorMessage = errorMessage + '- at least one special characters;\n';
            }
        }
        if (checkMessage === false) {
            return checkMessage;
        } else {
            return errorMessage;
        }
    },
    isEmptyObject: (obj) => {
        for (var i in obj) {
            if ({}.propertyIsEnumerable.call(obj, i)) {
                return false;
            }
        }
        return true;
    },
    genPassword: (len) => {
        var password = "";
        var symbols = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!№;%:?*()_+=";
        for (var i = 0; i < len; i++){
            password += symbols.charAt(Math.floor(Math.random() * symbols.length));
        }
        return password;
    },

    decodeHtmlEntity: (str) => {
        if (typeof str ==='string'){
            return str.replace(/&#(\d+);/g, function(match, dec) {
                return String.fromCharCode(dec);
            });
        } else {
            return str
        }
    },
    encodeHtmlEntity: (str) => {
        if (typeof str ==='string') {
            let buf = [];
            for (var i = str.length - 1; i >= 0; i--) {
                buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
            }
            return buf.join('');
        } else {
            return str
        }
    },
    checkError: async function(response){
        const fullErrorDescription = {
            auth_finish: 'Authentication time out',
            no_action: 'Action request parameter - not passed',
        }
        if(typeof response.result !== 'undefined'){
            if(response.data.status !== 'false')
            return response
        }
        if (typeof response.data.description === 'undefined'){
            this.errorWriter('Error not identified')
            return response
        }
        if(typeof fullErrorDescription[response.data.description] === 'undefined'){
            this.errorWriter('Error not identified')
            return response
        }

        switch(response.data.description){
            case 'auth_finish':
                this.errorWriter(fullErrorDescription[response.data.description])
                await store.dispatch("auth/SET_logout", 'sessionExpires')
                break
            default:
                this.errorWriter(fullErrorDescription[response.data.description])
        }
        return false
    },
    ajaxCheckSession: async function(urlRequest, dataRequest){
        //for development mode
        if (location.hostname !== 'localhost') {
            dataRequest.auth = store.getters["auth/authDonor"]
        }
        try {
            const response = await axios.post(urlRequest, QS.stringify(dataRequest));
            return await this.checkError(response)
        } catch (e) {
            console.log ('ERROR: ', e)
            store.commit('set_error', e)
            throw e
        }
    },
    camelCaseToSnackCase(world){
        return world.replace(/((?<=[a-z\d])[A-Z]|(?<=[A-Z\d])[A-Z](?=[a-z]))/g, '_$1').toLowerCase()
    },
    errorWriter(error){
        console.log(`ERROR : " ${error} "`)
        store.commit('set_error', error)
    },

    escapeRegExp: (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),



}
